export default __webpack_public_path__ + "static/media/screen_facebook_5_2.abfcbb33.png";